import { FileReader, FileWriter } from '@/platform'

/** 与 cg_v3 CompressFileData 装饰器顺序一致：MD5 → path */
export class CompressFileData {
    public MD5 = ''
    public path = ''

    readBin(reader: FileReader): void {
        this.MD5 = reader.readString()
        this.path = reader.readString()
    }

    writeBin(writer: FileWriter): void {
        writer.writeString(this.MD5)
        writer.writeString(this.path)
    }
}

/** 与 cg_v3 CompressFile：Data: CompressFileData[] */
export default class CompressFile {
    public Data: CompressFileData[] = []

    readBin(reader: FileReader): void {
        const n = reader.readInt()
        this.Data = []
        for (let i = 0; i < n; i++) {
            const d = new CompressFileData()
            d.readBin(reader)
            this.Data.push(d)
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            this.Data[i]!.writeBin(writer)
        }
    }
}
